import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { H2 } from '../Typography';

import styles from './styles';

function DialogTitle(props) {
    return (
        <div className={props.classes.root}>
            <H2 className={props.classes.header}>
                {props.children}
            </H2>
        </div>
    );
}

export default withStyles(styles)(DialogTitle);